import { PropsWithChildren } from 'react';
import { useUserPlanContext } from '@/creditflowresearch/application/User/UserPlan/UserPlanContext';
import UserPlan, { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import CheckUserAccess from '@/creditflowresearch/ui/common/components/CheckUserAccess';
import {
  getPremiumDescription,
} from '@/creditflowresearch/ui/common/components/organisms/constants';
import TileAccessFallback from '@/creditflowresearch/ui/common/components/organisms/TileAccessFallback';
import LogInButton from '@/creditflowresearch/ui/common/components/LogInButton';
import { useAccessGrant } from '@/creditflowresearch/application/User/access/grants/useAccessGrant';
import { useIsOpenAccessDeal } from '@/creditflowresearch/application/User/access/grants/OpenAccessDealContext';

import styles from './dealTile.module.scss';

interface IDealTileWithFallbackProps extends PropsWithChildren {
  userAccessChecks: boolean[],
}

const DealTileWithFallback = ({
  userAccessChecks,
  children,
}: IDealTileWithFallbackProps) => {
  const { checkAccessByUserPlan, plan } = useUserPlanContext();
  // on a deal card the grant comes from the deal itself, elsewhere from the page query
  const isOpenAccessDeal = useIsOpenAccessDeal();
  const granted = useAccessGrant() || isOpenAccessDeal;
  const checks = granted
    ? [true]
    : [
      ...userAccessChecks,
      checkAccessByUserPlan(UserPlanType.PREMIUM),
    ];
  const baseProps = {
    title: 'Recent New Issue',
    dataTest: 'dealTile',
    tooltipContent: 'Track transaction details across new issue activity from rumor to pricing',
    className: styles.fallbackContainer,
  };

  return (
    <CheckUserAccess
      conditions={ [
        {
          checks: [granted || !UserPlan.isUnauthorized(plan)],
          fallback: (
            <TileAccessFallback
              { ...baseProps }
              description={ null }
              actionButton={ <LogInButton withIcon={ false } variant="outline" /> }
            />
          ),
        },
        {
          checks,
          fallback: (
            <TileAccessFallback
              { ...baseProps }
              description={ (
                <div className={ styles.description }>
                  { getPremiumDescription() }
                </div>
              ) }
            />
          ),
        },
      ] }
    >
      { children }
    </CheckUserAccess>
  );
};

export default DealTileWithFallback;
